import React from "react";
import Seo from "@/components/Seo";
import { Breadcrumbs } from "@/components/layout/Breadcrumbs";
import { LeadMagnet } from "@/components/LeadMagnet";
import { CheckCircle2 } from "lucide-react";

export default function GuidaMobilita() {
  return (
    <>
      <Seo title="Guida gratuita alla mobilità per senior (PDF)"
        description="Scarica gratis la guida alla mobilità per senior: soluzioni, criteri di scelta, patente e agevolazioni. PDF a cura del Centro Mobilità Senior SENIORCAR."
        keywords="guida mobilità senior pdf, guida scooter elettrico anziani" />
      <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-6"><Breadcrumbs items={[{ label: "Guide", path: "/guide" }, { label: "Guida gratuita" }]} /></div>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 pt-6 grid lg:grid-cols-2 gap-10 items-center">
        <div>
          <span className="uppercase text-xs font-bold tracking-widest text-emerald-800 bg-emerald-100 px-3 py-1 rounded-full">Risorsa gratuita</span>
          <h1 className="mt-4 text-3xl sm:text-4xl font-extrabold text-slate-900 leading-tight" style={{ fontFamily: "Outfit" }}>Guida alla mobilità per senior</h1>
          <p className="mt-4 text-lg text-slate-600 leading-relaxed">Una guida chiara e pratica per aiutarti a scegliere la soluzione di mobilità giusta per te o per un tuo familiare, senza tecnicismi.</p>
          <ul className="mt-6 space-y-3">
            {["Le soluzioni disponibili a confronto", "Cosa valutare nella scelta", "Patente, targa e agevolazioni fiscali", "Come organizzare una prova"].map((t) => (
              <li key={t} className="flex items-center gap-2 text-slate-700 text-lg"><CheckCircle2 size={20} className="text-emerald-700" /> {t}</li>
            ))}
          </ul>
        </div>
        <LeadMagnet />
      </section>
      <div className="h-16" />
    </>
  );
}
